import React from "react";
import { BrowserRouter, Routes as Switch, Route } from "react-router-dom";

import { Box } from "@mui/material";
import Videos from "./components/Videos";
import VideoDetails from "./components/VideoPage";
import ScrollToTop from "./utils/ScrollToTop";

export const config = {
  // https://ed78f3ab-052b-41ca-af29-4fe7cd10d383.mock.pstmn.io/v1/videos

  endpoint: "https://ed78f3ab-052b-41ca-af29-4fe7cd10d383.mock.pstmn.io/v1/videos"
};

const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Box sx={{ backgroundColor: "#181818" }}>
        <Switch>
          <Route path="/" element={<Videos/>} />
          <Route path="/video/:id" element={<VideoDetails/>} />
        </Switch>
      </Box>
    </BrowserRouter>
  );
};

export default App;
